/*
 * @描叙: 设备监控API 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-03-06 13:54:09 
*/

import { $post } from '@/utils/http'
import Service from './Service'

// 获取设备监控列表
Service.getEmcsList = async function () {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    let data = await $post('/ucenter/v2/map/dataset', request, true);
    return Service.handleCommonError(data)
}

// 获取单个设备监控
Service.getEmcsInfo = async function (params) {
    let request = {}
    // 监控OID
    request['oid'] = params.oid

    let data = await $post('/ucenter/v2/map/data', request, true);
    return Service.handleCommonError(data)
}

// 添加设备监控
Service.addEmcs = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 监控名称
    request['map_name'] = params.map_name
    // 监控设备ID集合[{"oid":1},{"oid":2}]
    request['terminal_oid'] = JSON.stringify(params.terminal_oid)
    // 监控模板JSON字符串
    request['map_value'] = params.map_value

    let data = await $post('/ucenter/v2/map/addmap', request);
    return Service.handleCommonError(data)
}

// 修改设备监控
Service.editEmcs = async function (params) {
    let request = {}
    
    // 监控OID
    request['oid'] = params.oid
    // 监控名称
    request['map_name'] = params.map_name
    // 监控设备ID集合[{"oid":1},{"oid":2}]
    request['terminal_oid'] = JSON.stringify(params.terminal_oid)
    // 监控模板JSON字符串
    request['map_value'] = params.map_value

    let data = await $post('/ucenter/v2/map/editmap', request);
    return Service.handleCommonError(data)
}


// 删除设备监控
Service.delEmcs = async function (params) {
    let request = {}
    // 监控OID
    request['oid'] = params.oid
    

    let data = await $post('/ucenter/v2/map/delmap', request);
    return Service.handleCommonError(data)
}